<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="vc_pzname" :label="$t('form_product_name')" >{{formData.vc_pzname}}</el-form-item>
            <el-form-item  prop="vc_gsname" :label="$t('form_company')" >{{formData.vc_gsname}}</el-form-item>
            <el-form-item  prop="vc_ckname" :label="$t('form_warehouse')" >{{formData.vc_ckname}}</el-form-item>
            <el-form-item  prop="vc_wzname" label="货位" >{{formData.vc_wzname}}</el-form-item>
            <el-form-item  prop="i_xtype" label="货物性质" >{{formData.i_xtype==0?'内销':formData.i_xtype==1?'外销':formData.i_xtype==2?'电商库存':''}}</el-form-item>
            <el-form-item label="变更货物性质:"class="w50"  prop="i_xtype_new" >
                <el-radio-group :disabled="canEdit" v-model="formData.i_xtype_new" @input="i_xtypeChange" >
                    <el-radio :label='0'>内销</el-radio>
                    <el-radio :label='1' v-if="formData.i_scid!=0">外销</el-radio>
                    <el-radio :label='2'>电商库存</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item  prop="i_wzid_new" label="转移货位" >

                <el-select :disabled="canEdit" style="width: 200px" @change="i_wzidChange"  class="marr4" v-model="formData.i_wzid_new" size="mini"  filterable placeholder="转移货位">
                    <el-option v-for="item in hwList" :key="item.id" :label="item.area" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="mini" >保存</el-button>
            </template>

            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "ChanpinFenlei",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                formData:{
                    i_id:0,
                    vc_name:'',
                    i_flag:'',
                    i_gsid:'',
                    i_gid:'',
                    i_order:'',i_state:1,i_xtype_new:'',i_wzid_new:'',
                },
                disabled:false,
                canEdit:false,
                sxList:[],
                gszzList:[],
                hwList:[],
                // xtypeList:[{i_id:0,vc_name:'内销',show:true},{i_id:1,vc_name:'外销',show:true},{i_id:1,vc_name:'电商库存',show:true}],
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    if(this.data){
                        this.formData=this.data;
                        this.formData.i_xtype_new=this.data.i_xtype;
                        this.formData.i_wzid_new=this.data.i_wzid;
                        // if(this.formData.i_scid==0){
                        //  this.xtypeList[1].show=false
                        // }
                    }
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.getList()

            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            i_xtypeChange(){
                // console.log(this.formData.i_xtype_new)
                this.$forceUpdate()
            },
            i_wzidChange(){
                // console.log(this.formData.i_xtype_new)
                this.$forceUpdate()
            },
            cancel(){
                this.$emit('close')
            },
            saveForm(){
                this.editStock()
                this.disabled=true
            },
            async editStock(){

                let param=this.formData;
                let res=await API.editStock(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
            async getList(){
                let param={
                    khid:this.data.i_ckid,
                };
                let res=await API.getList(param);
                if ( res.code == 1 ){
                    this.hwList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
.dib{
    display: inline-block;
}
    .marr4{
        margin-right: 8px;
    }
</style>